import { defineComponent as _defineComponent } from 'vue'
import { VignetteRoutes } from "@/types";
import DjangoRouterLink from "@/components/links/DjangoRouterLink.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ApplicationFooter',
  setup(__props) {


return { __sfc: true,VignetteRoutes, DjangoRouterLink }
}

})